export const colors = {
  yellow: {
    50: "#fefce8",
    100: "#fdedd3",
    200: "#fbdba7",
    300: "#f9c97c",
    400: "#f7b750",
    500: "#f5a524",
    600: "#c4841d",
    700: "#936316",
    800: "#62420e",
    900: "#312107",
  },
  primary: {
    "50": "#F9E8E9",
    "100": "#F3D2D4",
    "200": "#E8A5AA",
    "300": "#DD7880",
    "400": "#D24B56",
    "500": "#C71F2C",
    "600": "#9F1823",
    "700": "#77121A",
    "800": "#4F0C11",
    "900": "#270608",
  },
};
